import { SignInOption } from '~/modules/sign-in/types/sign-in-option.type';
import { SignInOptionsResponse } from '~/modules/sign-in/types/sign-in-options-response.type';

export class AuthOptionsService {
  static $inject = ['$http'];

  constructor(private $http: angular.IHttpService) {}

  public optionsIncludeOnlyOneSaml(options: Array<SignInOption>) {
    return options.filter((option) => option.saml).length === 1;
  }

  public addPreferredNameToOptions(options: Array<SignInOption>): Array<SignInOption> {
    // if the options include only one single SAML option
    if (this.optionsIncludeOnlyOneSaml(options)) {
      // then add a preferredName property to that option
      return options.map((option) => {
        if (option.saml) {
          option.preferredName = option.name;
        }
        return option;
      });
    } else {
      return options;
    }
  }

  public getSignInOptions(name: string, paramsObj = {}): angular.IPromise<SignInOptionsResponse> {
    return this.$http
      .get('/api/signin_options/' + name, {
        params: paramsObj,
      })
      .then((response: any) => {
        const { data } = response;
        return {
          claimedDomain: data.claimed_domain,
          signInOptions: this.addPreferredNameToOptions(data.signin_options),
          avatar: data.org_avatar,
        };
      });
  }
}
